export default function Spacer({ size = "medium" }) {
  const sizeMap = {
    small: "h-2",
    medium: "h-6",
    large: "h-12",
  };

  const sizeClass = sizeMap[size];
  if (!sizeClass) {
    throw new Error(`Invalid size: ${size}`);
  }

  return <div className={sizeClass} />;
}
